import React from 'react'
import { Flex, styled } from '@fareye/ui'
import { SpanModify } from '../../../style/styled'

const ColorSpan = (styled as any)(SpanModify)`
  color: ${(props: any) => props.theme.colors[props?.title || 'inherit']};
`
function FieldValue({ style, label, value, labelStyle, valueStyle }: any) {
  return (
    <Flex
      alignItemsFlexEnd
      style={{
        justifyContent: label ? 'space-between' : 'flex-start',
        ...style
      }}
    >
      {label && (
        <SpanModify style={{ color: 'inherit', ...labelStyle }}>
          {label}&nbsp;
        </SpanModify>
      )}
      {value ? (
        <ColorSpan title={value} style={{ ...valueStyle }}>
          {value}
        </ColorSpan>
      ) : (
        <SpanModify style={{ color: 'inherit' }}>&nbsp;</SpanModify>
      )}
    </Flex>
  )
}

export default FieldValue
